/* albums-listing.js — /collections/albums client behavior, FULL parity with
   yalladj-new AlbumsClient.tsx: search combobox (title suggestions, keyboard
   nav), on-sale-only toggle, 5-key client sort (featured / price-low /
   price-high / tracks-most / discount), result count, clear. Operates on the
   server-rendered page (server order = Featured). Degrades gracefully: with
   JS off all server-rendered cards remain visible and every card link and
   add-to-cart form still works. */
(function () {
  'use strict';

  var MAX_SUGGESTIONS = 8;

  function initSection(root) {
    var grid = root.querySelector('[data-albums-grid]');
    if (!grid) { return; }

    var searchWrap = root.querySelector('[data-albums-search]');
    var searchInput = root.querySelector('[data-search-input]');
    var suggestionsEl = root.querySelector('[data-suggestions]');
    var toggle = root.querySelector('[data-on-sale-toggle]');
    var sortSelect = root.querySelector('[data-albums-sort]');
    var countEl = root.querySelector('[data-albums-count]');
    var clearBtn = root.querySelector('[data-albums-clear]');
    var clearCountEl = clearBtn ? clearBtn.querySelector('[data-clear-count]') : null;
    var emptyFiltered = root.querySelector('[data-albums-empty-filtered]');
    var clearFiltersBtn = root.querySelector('[data-clear-filters]');

    var items = Array.prototype.slice.call(grid.querySelectorAll('.albums-grid__item'));
    items.forEach(function (li, i) { li.setAttribute('data-index', String(i)); });

    // Deduped album titles -> suggestion source (matches AlbumsClient).
    var titleSuggestions = [];
    (function () {
      var seen = {};
      items.forEach(function (li) {
        var title = (li.getAttribute('data-title') || '').trim();
        var key = title.toLowerCase();
        if (title && !seen[key]) {
          seen[key] = true;
          titleSuggestions.push(title);
        }
      });
    })();

    var activeIndex = -1;
    var visibleSuggestions = [];
    var lastAppliedSort = 'featured';

    function num(li, attr) {
      var v = parseFloat(li.getAttribute(attr) || '0');
      return isNaN(v) ? 0 : v;
    }

    function currentSort() {
      return sortSelect ? sortSelect.value : 'featured';
    }

    function sortItems(list) {
      var sorted = list.slice();
      switch (currentSort()) {
        case 'price-low':
          sorted.sort(function (a, b) { return num(a, 'data-price') - num(b, 'data-price'); });
          break;
        case 'price-high':
          sorted.sort(function (a, b) { return num(b, 'data-price') - num(a, 'data-price'); });
          break;
        case 'tracks-most':
          sorted.sort(function (a, b) { return num(b, 'data-tracks') - num(a, 'data-tracks'); });
          break;
        case 'discount':
          sorted.sort(function (a, b) { return num(b, 'data-discount') - num(a, 'data-discount'); });
          break;
        default:
          sorted.sort(function (a, b) { return num(a, 'data-index') - num(b, 'data-index'); });
      }
      return sorted;
    }

    function apply() {
      var q = searchInput ? searchInput.value.trim().toLowerCase() : '';
      var onSale = toggle ? toggle.checked : false;
      var visible = 0;

      // Re-append (reorder) only when the sort key actually changed —
      // search keystrokes and toggles just flip li.hidden.
      var sortKey = currentSort();
      if (sortKey !== lastAppliedSort) {
        sortItems(items).forEach(function (li) { grid.appendChild(li); });
        lastAppliedSort = sortKey;
      }

      items.forEach(function (li) {
        var title = (li.getAttribute('data-title') || '').toLowerCase();
        var show = true;
        if (onSale && li.getAttribute('data-on-sale') !== 'true') { show = false; }
        if (show && q && title.indexOf(q) === -1) { show = false; }
        li.hidden = !show;
        if (show) { visible++; }
      });

      if (countEl) {
        var noun = visible === 1 ? countEl.getAttribute('data-count-singular') : countEl.getAttribute('data-count-plural');
        countEl.textContent = visible + ' ' + noun;
      }

      var activeN = (onSale ? 1 : 0) + (q ? 1 : 0);
      if (clearBtn) {
        clearBtn.hidden = activeN === 0;
        if (clearCountEl) { clearCountEl.textContent = String(activeN); }
      }

      var noMatches = activeN > 0 && visible === 0;
      if (emptyFiltered) { emptyFiltered.hidden = !noMatches; }
      grid.hidden = noMatches;
    }

    /* --- Suggestions combobox --- */
    function hideSuggestions() {
      if (!suggestionsEl) { return; }
      suggestionsEl.hidden = true;
      activeIndex = -1;
      if (searchInput) {
        searchInput.setAttribute('aria-expanded', 'false');
        searchInput.removeAttribute('aria-activedescendant');
      }
    }

    function renderSuggestions() {
      if (!suggestionsEl || !searchInput) { return; }
      var q = searchInput.value.trim().toLowerCase();
      visibleSuggestions = (q
        ? titleSuggestions.filter(function (t) { return t.toLowerCase().indexOf(q) !== -1; })
        : titleSuggestions.slice()
      ).slice(0, MAX_SUGGESTIONS);

      suggestionsEl.textContent = '';
      if (visibleSuggestions.length === 0) {
        hideSuggestions();
        return;
      }
      // Options are plain <li role="option"> text — no focusable children, so
      // DOM focus stays on the input per the ARIA combobox pattern; selection
      // happens on mousedown (before blur can hide the list).
      visibleSuggestions.forEach(function (title, i) {
        var li = document.createElement('li');
        li.id = suggestionsEl.id + '-option-' + i;
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
        li.setAttribute('data-suggestion-title', title);
        li.className = 'albums-search__suggestion' + (i === activeIndex ? ' albums-search__suggestion--active' : '');
        li.textContent = title;
        suggestionsEl.appendChild(li);
      });
      suggestionsEl.hidden = false;
      searchInput.setAttribute('aria-expanded', 'true');
      if (activeIndex >= 0) {
        searchInput.setAttribute('aria-activedescendant', suggestionsEl.id + '-option-' + activeIndex);
      } else {
        searchInput.removeAttribute('aria-activedescendant');
      }
    }

    function selectSuggestion(title) {
      if (searchInput) { searchInput.value = title; }
      hideSuggestions();
      apply();
    }

    function reset() {
      if (toggle) { toggle.checked = false; }
      if (searchInput) { searchInput.value = ''; }
      hideSuggestions();
      apply();
      // The clicked clear control hides itself — move focus to a visible
      // successor so keyboard/AT users aren't left on a hidden node.
      if (searchInput) { searchInput.focus(); }
    }

    /* --- Wiring --- */
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        activeIndex = -1;
        renderSuggestions();
        apply();
      });
      searchInput.addEventListener('focus', renderSuggestions);
      searchInput.addEventListener('blur', hideSuggestions);
      searchInput.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Tab') {
          hideSuggestions();
          return;
        }
        if (!suggestionsEl || suggestionsEl.hidden || visibleSuggestions.length === 0) { return; }
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          activeIndex = (activeIndex + 1) % visibleSuggestions.length;
          renderSuggestions();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          activeIndex = activeIndex <= 0 ? visibleSuggestions.length - 1 : activeIndex - 1;
          renderSuggestions();
        } else if (e.key === 'Enter') {
          if (activeIndex >= 0 && activeIndex < visibleSuggestions.length) {
            e.preventDefault();
            selectSuggestion(visibleSuggestions[activeIndex]);
          }
        }
      });
    }
    if (suggestionsEl) {
      // mousedown fires before the input's blur, so selection wins the race
      // with hideSuggestions; options aren't focusable, focus stays on input.
      suggestionsEl.addEventListener('mousedown', function (e) {
        var option = e.target.closest ? e.target.closest('[data-suggestion-title]') : null;
        if (!option) { return; }
        e.preventDefault();
        selectSuggestion(option.getAttribute('data-suggestion-title'));
      });
    }
    if (toggle) { toggle.addEventListener('change', apply); }
    if (sortSelect) { sortSelect.addEventListener('change', apply); }
    if (clearBtn) { clearBtn.addEventListener('click', reset); }
    if (clearFiltersBtn) { clearFiltersBtn.addEventListener('click', reset); }
    if (searchWrap) { searchWrap.addEventListener('submit', function (e) { e.preventDefault(); }); }
  }

  function init() {
    var roots = document.querySelectorAll('[data-albums-listing]');
    Array.prototype.forEach.call(roots, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
